import { render, staticRenderFns } from "./geogebra-wrapper.vue?vue&type=template&id=678973da&scoped=true&"
import script from "./geogebra-wrapper.vue?vue&type=script&lang=js&"
export * from "./geogebra-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678973da",
  null
  
)

export default component.exports